import React, {useState, createContext} from 'react'

export const ErrorContext = createContext()

export const ErrorProvider = (props) => {
    const[errorState, setErrorState] = useState({})
    return (
        <ErrorContext.Provider value={[errorState,setErrorState]}>
            {props.children}
        </ErrorContext.Provider>
    )
}